<template>
  <div class="summaryDetail">
    <el-form ref="form">
      <el-row class="tit">
        <el-col :span="24">{{staffName}}的服务明细</el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="19">
          <el-table
            v-if="tableData.length > 0"
            :data="tableData"
            border
            :cell-style="{height:'42px'}"
            style="width: 100%"
            :header-cell-style="{background:'#EFF1F5',height:'47px'}"
          >
            <el-table-column align="center" prop="memberName" label="会员名称"></el-table-column>
            <el-table-column align="center" prop="memberTelephone" label="会员手机号" width="105"></el-table-column>
            <el-table-column align="center" prop="serviceName" show-overflow-tooltip label="服务名称"></el-table-column>
            <el-table-column align="center" prop="createTime" show-overflow-tooltip label="变动时间"></el-table-column>
            <el-table-column align="center" prop="courseStyle" show-overflow-tooltip label="计量方式">
                <template slot-scope="scope">
                    {{scope.row.courseStyle == 1 ? '计次' : '计时'}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="originalFrequency" show-overflow-tooltip label="原有服务持有情况">
                <template slot-scope="scope">
                    {{scope.row.originalFrequency ? scope.row.originalFrequency : scope.row.serviceStartDate}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="changeFrequency" show-overflow-tooltip label="变动情况">
                <template slot-scope="scope">
                    {{scope.row.changeFrequency ? scope.row.changeFrequency : scope.row.serviceEndDate}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="nowFrequency" show-overflow-tooltip label="现有服务持有情况">
                <template slot-scope="scope">
                    {{scope.row.nowFrequency ? scope.row.nowFrequency : scope.row.serviceEndDate}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="technicianNameStore" show-overflow-tooltip label="操作员工"></el-table-column>
            <el-table-column align="center" prop="changeType" show-overflow-tooltip label="变动类型">
                <template slot-scope="scope">
                    {{scope.row.changeType == 1 ? '购买变动':(scope.row.changeType == 2?'消费变动':(scope.row.changeType == 3?'退服务变动':(scope.row.changeType == 5?'服务次数调整':'--')))}}
                </template>
            </el-table-column>
          </el-table>
          <span v-else>无</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="23">
          <div class="btnOptions">
            <el-button class="darkBtn" @click="closeTab">关闭</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-pagination
        v-if="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px;text-align:right"
      ></el-pagination>

  </div>
</template>
<script type="text/javascript">
import {pageMemberServiceChanges} from '@/api'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      staffName:'',
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData:'',
    };
  },
  created() {
    this.detailInfo();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    detailInfo() {
        pageMemberServiceChanges({
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          orderServeDetailsId:this.$route.params.id
        }).then(res=>{
          this.total = res.data.totalNum;
          this.tableData = res.data.items;
        })
        this.$nextTick(()=>{
          this.staffName = this.$route.query.name ? this.$route.query.name : this.$route.params.tel;
        })
    },
    closeTab() {
      // 关闭当前tab
      this.$router.push("/financeManageCenter/memServiceForm");
    },
  }
};
</script>
<style lang="less" scoped>
.summaryDetail {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .el-row.tit {
    color: #444;
    margin-bottom: 30px;
  }
  .el-row {
    margin-bottom: 15px;
  }
  .seize {
    height: 20px;
  }
}
</style>
<style lang="less">
.summaryDetail {
  .el-table td,
  .el-table th {
    padding: 0;
  }
  .btnOptions {
    text-align: center;
    margin: 0;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/memServiceDetail.vue